import React, { useState, useEffect } from "react";
import { BaseUrl } from "../..";
import { Link } from "react-router-dom";
import { formatDate } from "../utils/utils";

function Results() {
  const [shows, setShows] = useState([]);
  const [luckyNoData, setLuckyNoData] = useState([]);
  const [luckyNoWeekrange, setLuckyNoWeekrange] = useState("");

  const API_URL_S = `${BaseUrl}get-all-show`;
  const fetchShows = async () => {
    try {
      const response = await fetch(API_URL_S, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
      });
      const result = await response.json();
      if (result.status === "Success") {
        setShows(result.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const API_URL_L = `${BaseUrl}weeklyluckynumbers`;
  const getluckyNoData = async () => {
    try {
      const response = await fetch(API_URL_L, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
      });
      const result = await response.json();
      if (result.status === "Success") {
        setLuckyNoWeekrange(result.week_range);
        setLuckyNoData(result.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    fetchShows();
    getluckyNoData();
  }, []);
  return (
    <>
      <section id="results" className="section">
        <h2>आज के लाइव रिजल्ट</h2>
        <div className="results">
          {shows.slice(0, 3).map((val, index) => (
            <div className="result-card" key={index}>
              <h3>{val.ShowName}</h3>

              <span>
                <p>{val.OpenTime}</p>
                <strong>
                  {val.panel_entries.length >= 2
                    ? `${val.panel_entries[0].PannaOne}${val.panel_entries[0].PannaTwo}${val.panel_entries[0].PannaThree}-${val.panel_entries[0].Akhar}
                     ${val.panel_entries[1].Akhar}-${val.panel_entries[1].PannaOne}${val.panel_entries[1].PannaTwo}${val.panel_entries[1].PannaThree}`
                    : val.panel_entries.length === 1
                    ? `${val.panel_entries[0].PannaOne}${val.panel_entries[0].PannaTwo}${val.panel_entries[0].PannaThree}-${val.panel_entries[0].Akhar} *-***`
                    : "***-* *-***"}
                </strong>

                {/* <strong>
                  {val.panel_entries.length
                    ? `${val.panel_entries[0].PannaOne}${val.panel_entries[0].PannaTwo}${val.panel_entries[0].PannaThree}-${val.panel_entries[0].Akhar}
                     ${val.panel_entries[1].Akhar}-${val.panel_entries[1].PannaThree}${val.panel_entries[1].PannaTwo}${val.panel_entries[1].PannaOne}`
                    : "***-* *-***"}
                </strong> */}
                <p>{val.CloseTime}</p>
              </span>

              <div className="result-buttons">
                <Link to={`/jodi/${val.JodiAlias}`} className="btn-panel">
                  Jodi
                </Link>
                <Link to={`/panel/${val.PanelAlias}`} className="btn-panel">
                  Panel
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
      <section className="weekly-line-section">
        <div className="weekly-line-header">
          <p>Madhu Shree Net Weekly Line Open Or Close From</p>
          <p>
            <span className="highlight-red">
              {luckyNoWeekrange?.start
                ? formatDate(luckyNoWeekrange.start)
                : "-"}
            </span>
            <br />
            To
            <br />
            <span className="highlight-red">
              {luckyNoWeekrange?.end ? formatDate(luckyNoWeekrange.end) : "-"}
            </span>
          </p>
          <p>For Madhu Shree</p>
        </div>

        <div className="weekly-line-body">
          {[
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
          ].map((day) => {
            const dayData = luckyNoData?.find((item) => item.day === day);
            return (
              <p key={day}>
                <span className="day">{day}</span>{" "}
                {dayData
                  ? `${dayData.LN1} - ${dayData.LN2} - ${dayData.LN3} - ${dayData.LN4}`
                  : "* - * - * - *"}{" "}
              </p>
            );
          })}
        </div>
      </section>
      <section id="results" className="section">
        <h2>आज के लाइव रिजल्ट</h2>
        <div className="results">
          {shows.slice(3).map((val, index) => (
            <div className="result-card" key={index}>
              <h3>{val.ShowName}</h3>
              <span>
                <p>{val.OpenTime}</p>
                <strong>
                  {val.panel_entries.length >= 2
                    ? `${val.panel_entries[0].PannaOne}${val.panel_entries[0].PannaTwo}${val.panel_entries[0].PannaThree}-${val.panel_entries[0].Akhar}
                     ${val.panel_entries[1].Akhar}-${val.panel_entries[1].PannaOne}${val.panel_entries[1].PannaTwo}${val.panel_entries[1].PannaThree}`
                    : val.panel_entries.length === 1
                    ? `${val.panel_entries[0].PannaOne}${val.panel_entries[0].PannaTwo}${val.panel_entries[0].PannaThree}-${val.panel_entries[0].Akhar} *-***`
                    : "***-* *-***"}
                </strong>
                <p>{val.CloseTime}</p>
              </span>
              <div className="result-buttons">
                <Link to={`/jodi/${val.JodiAlias}`} className="btn-panel">
                  Jodi
                </Link>
                <Link to={`/panel/${val.PanelAlias}`} className="btn-panel">
                  Panel
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default Results;
